import autoplanner, {
  addAutoPlannerTripSlice,
  autoPlannerAgentSlice,
  autoPlannerRouteSlice,
  deleteAutoPlannerSliceSlice,
  upadateAutoPlannerTripSlice,
  importAutoPlannerTripSlice,
  addAutoPlannerBookingSlice,
  GRPTrip,
  newPickupLocation,
  allBookings,
  validateContact,
  getAdhocVehicleReducer,
  getAdhocTransferVehicleReducer,
  AddAdhocVehicleReducer
} from './autoPlannerSlices/autoplanner';

import {
  autoGeneratedTripSlice,
  deleteAutoGeneratedSliceSlice,
  updateAutoGeneratedTripSlice,
  autoPlannerReportSlice,
  scheduleTripSlice,
  deleteAutoGeneratedBooking,
  modeVehicle,
  deleteScheduleReducer,
  deleteScheduleBookingReducer,
  sicBookingsUpdateReducer,
  getStandardVehiclesReducer,
  PVTGRPScheduleUpdate,
  switchTripSlice,
  filterVehicle,
  getExcelReducer,
  getMainHotelsData,
  transferDriver,
  driverChange,
  agentTourDropdown,
  notifyAgent,
  sendwhatsapp,
  guestContactUpdate,
  publishTrips,
  getStandardDriverNamesReducer
} from './autoPlannerSlices/autoGenerateSlice';

import autoplannerConfigurationSlice, {
  addRouteConfigure,
  agentBulkImport,
  configurableTime,
  deleteRouteConfigure,
  filterRoute,
  timeGETconfiguration,
  updateRouteConfigure,
  vechileconfiguration,
  vechileupdate
} from './autoPlannerSlices/autoplannerConfigurationSlice';
import {
  pickupLocation,
  updatePickupConfigure
} from './autoPlannerSlices/pickupConfigurationSlice';
import { uploadLoaderSlice } from './autoPlannerSlices/excelLoaderSlice';

import agentslice, {
  addAgentDetails,
  agentDelete,
  agentUpdate,
  agentValidation,
  rateCard,
  validateAgent
} from './autoPlannerSlices/agentslice';

import {
  asyncSuccessData,
  availableSummary,
  deleteSummary,
  downloadSummary,
  initialTourSummarySlice,
  summaryDrivers,
  tourSummaryPlanFrozenSlice,
  tourSummaryProccedResultSlice,
  tourSummaryProccedSlice,
  transferVehicleDropdown,
  updateSummaryDrivers
} from './autoPlannerSlices/tourSummary';

import vehicleManagementSlice, {
  updateVechile
} from './autoPlannerSlices/vehicleManagementSlice';
import {
  liveTracking,
  transportReached,
  tripTracking
} from '../../../../common/redux/reducer/commonSlices/tripTrackingSlice';
import {
  autoplannerReportsPDFExcelData,
  externalVehicleReportData
} from '../../../yaantrac/redux/reducer/yaantracSlices/reportSlice';
import {
  deactivateVehicle,
  dropIMEI,
  dropSIM,
  planID,
  vehicleDelete,
  vehicleMake,
  vehicleModel,
  vehicleOnboardAdd,
  vehiUpdate
} from '../../pages/configurations/vehicleconfiguration/components/vehicleOnboard';
import {
  dashboardDriver,
  tripUpdate
} from '../../pages/configurations/driverDashboard/driverDashboardSlice';
import {
  addRegularData,
  deactivateRegularData,
  deleteRegularData,
  getConfigurableVehiclesData,
  getRegularDriversData,
  getRegularTourData,
  updateRegularTourData
} from './autoPlannerSlices/regularSlices';
import { getTodayToursData } from './autoPlannerSlices/todayToursSlice';
import { Time } from 'highcharts';
import { userRoleGET } from '../../../../common/redux/reducer/commonSlices/roleSlice';
import {
  addRateCardDetailsReducer,
  childComponent,
  deleteRateCardslice,
  getRateCardDetailsSlice,
  getSeatersListSlice,
  getToursListSlice,
  updateRatecardDeatilsReducer
} from './autoPlannerSlices/rateCardSlice';

export const autoPlannerReducer = {
  AutoPlannerTrip: autoplanner,
  AutoPlannerAddTrip: addAutoPlannerTripSlice,
  AutoPlannerBooking: addAutoPlannerBookingSlice,
  AutoPlannerUpdateTrip: upadateAutoPlannerTripSlice,
  importAutoPlannerTrip: importAutoPlannerTripSlice,
  newPickupLocation: newPickupLocation,
  AutoPlannerDeleteTrip: deleteAutoPlannerSliceSlice,
  AutoGeneratedTrip: autoGeneratedTripSlice,
  scheduleTrip: scheduleTripSlice,
  switchTrip: switchTripSlice,
  modeVehicle: modeVehicle,
  AutoGeneratedUpdateTrip: updateAutoGeneratedTripSlice,
  AutoGeneratedDeleteTrip: deleteAutoGeneratedSliceSlice,
  AutoGeneratedBookingDelete: deleteAutoGeneratedBooking,

  autoPlannerAgent: autoPlannerAgentSlice,
  autoPlannerRoutes: autoPlannerRouteSlice,
  addRouteConfigure: addRouteConfigure,
  updateRouteConfigure: updateRouteConfigure,
  deleteRouteConfigure: deleteRouteConfigure,
  vechileconfiguration: vechileconfiguration,
  updateVechile: vechileupdate,
  filterRouteDetails: filterRoute,
  autoplannerAgent: agentslice,
  agentOnboard: addAgentDetails,
  autoAgentUpdate: agentUpdate,
  autoagentDelete: agentDelete,
  initialTourSummary: initialTourSummarySlice,
  tourSummaryPlanFrozen: tourSummaryPlanFrozenSlice,
  tourSummaryProcced: tourSummaryProccedSlice,
  deleteSchedule: deleteScheduleReducer,
  deleteScheduleBooking: deleteScheduleBookingReducer,
  tripGRP: GRPTrip,
  sicBookingsUpdate: sicBookingsUpdateReducer,
  getStandardVehicles: getStandardVehiclesReducer,
  getStandardDriverNames: getStandardDriverNamesReducer,
  transferVehicles: transferVehicleDropdown,
  updatePvtGrpScheduled: PVTGRPScheduleUpdate,
  availableSummary: availableSummary,
  summaryDriversList: summaryDrivers,
  updateSummaryDrivers: updateSummaryDrivers,
  vehicleDropdown: filterVehicle,
  getExcel: getExcelReducer,
  mainHotels: getMainHotelsData,
  Driverdrop: transferDriver,
  changeDriver: driverChange,
  downloadSummary: downloadSummary,
  tourSummaryProccedResult: tourSummaryProccedResultSlice,
  excelImportAgents: agentBulkImport,
  dropdownAgentTour: agentTourDropdown,
  pickupLocation: pickupLocation,
  updatePickupConfigure: updatePickupConfigure,
  uploadLoader: uploadLoaderSlice,
  getVechile: vehicleManagementSlice,
  updatevehiclemananage: updateVechile,
  autoGetRoute: autoplannerConfigurationSlice,
  autoPlannerMail: autoPlannerReportSlice,
  AgentNotification: notifyAgent,
  liveTracking: liveTracking,
  tripTrackingSlice: tripTracking,
  sendwhatsapp: sendwhatsapp,
  transportReached: transportReached,

  deleteSummary: deleteSummary,
  ExternalVehicle: externalVehicleReportData,
  autoPDFExcel: autoplannerReportsPDFExcelData,
  dropdownIMEI: dropIMEI,
  dropdownSIM: dropSIM,
  dropdownPlanID: planID,
  dropdownVehicleMake: vehicleMake,
  dropdownVehicleModel: vehicleModel,
  onboardVehicle: vehicleOnboardAdd,
  updateVehi: vehiUpdate,
  activateVehicle: deactivateVehicle,
  contactguest: guestContactUpdate,
  agentValidation: validateAgent,
  driverTripData: dashboardDriver,
  UpdateGuest: tripUpdate,
  asyncSuccess: asyncSuccessData,
  configurableVehicles: getConfigurableVehiclesData,
  regularDrivers: getRegularDriversData,
  addRegular: addRegularData,
  updateRegular: updateRegularTourData,
  deleteRegular: deleteRegularData,
  deactivateRegular: deactivateRegularData,
  getRegular: getRegularTourData,
  allBookings: allBookings,
  todayTours: getTodayToursData,
  DeleteAutoVehicle: vehicleDelete,
  ContactNumberValidation: validateContact,
  publishBookings: publishTrips,
  getAdhocVehicle: getAdhocVehicleReducer,
  getAdhocTransferVehicle: getAdhocTransferVehicleReducer,
  AddAdhocVehicle: AddAdhocVehicleReducer,
  RateCardGet: rateCard,
  TimeConfiguration: configurableTime,
  ConfiguredTime: timeGETconfiguration,
  GETuserRole: userRoleGET,
  getSeatersListReducer: getSeatersListSlice,
  getToursListReducer: getToursListSlice,
  getRateCardDetailsReducer: getRateCardDetailsSlice,
  updateRatecardDeatils: updateRatecardDeatilsReducer,
  addRateCardDetails: addRateCardDetailsReducer,
  deleteRateCard: deleteRateCardslice,
  childComponent: childComponent
};
